<template>
  <div class="box02-body" id="scroll-target"
    style="height:calc(100vh - 114px);"
    @scroll="handleScrollChild"
    v-elScroll="action.scroll"
    >
    <slot></slot>
    <div v-show="!state.complete" ref="LoadingBlock">
      <FontawesomeIcon :icon="['fal','spinner-third']" size="2x" class="mt40 mb200 icn fa-spin" />
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import * as _ from 'lodash'

/**
 * @props complete 追加読み込みの完了フラグ。
 * 
 * @emit scroll スクロールしたときに発生するイベント
 * @emit bottomDisplayed スクロール最下部（ローディングアイコン）が表示されたときに発生するイベント
 */
export default defineComponent({
  name: 'PCScrollList',
  props: {
    complete: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const LoadingBlock = ref(null)
    const state = reactive({
      loadingHeight: 0,
      complete: computed(() => props.complete)
    })
    const action = {
      scroll: (evt, el) => {
        // context.emit('scroll', el)
        // 追加読み込みなしの場合は、スクロールイベントを無視する
        if (state.complete) {
          return
        }
        const { scrollTop, offsetHeight, scrollHeight } = el
        // loading要素が画面内に表示されたらイベント発行
        if (scrollTop + offsetHeight >= scrollHeight - state.loadingHeight) {
          context.emit('bottomDisplayed')
        }
      }
    }

    const handleScrollChild = (e) => {
      context.emit('scroll', e)
    }

    // mount時にローディング要素部分の高さ(+margin)を取得
    onMounted(() => {
      const { offsetHeight } = LoadingBlock.value
      state.loadingHeight = offsetHeight + 40 + 100
      // if (state.additionalLoading) {
      // state.loadingHeight = LoadingBlock.value.offsetHeight + 40 + 100
      // state.loadingHeight = LoadingBlock.value.offsetHeight + 40
      // }
    })

    return {
      action,
      state,
      LoadingBlock,
      handleScrollChild
    }
  },
  // 要素のスクロールイベントをディレクティブに追加
  directives: {
    elScroll: {
      bind: (el, binding, vnode) => {
        vnode.context.$nextTick(() => {
          // IE11 対応
          if (document.documentMode) {
            const eve = document.createEvent('Event')
            eve.initEvent('scroll', false, false)
            el.dispatchEvent(eve)
          } else {
            el.dispatchEvent(new Event('scroll'))
          }
        })
      },
      inserted: (el, binding) => {
        const f = (evt) => {
          if (binding.value(evt, el)) {
            el.removeEventListener('scroll', _.throttle(f, 300))
          }
        }
        el.addEventListener('scroll', _.throttle(f, 300))
      },
      // リスト更新時に絞り込み等でscrollイベントが発生しない可能性があるため、更新時にイベント発火
      update: (el, binding, vnode) => {
        vnode.context.$nextTick(() => {
          // IE11 対応
          if (document.documentMode) {
            const eve = document.createEvent('Event')
            eve.initEvent('scroll', false, false)
            el.dispatchEvent(eve)
          } else {
            el.dispatchEvent(new Event('scroll'))
          }
        })
      }
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
